import React, { useEffect, useState } from 'react';
import ManageClassroomTable from './table';
import ManageClassroomCssTable from './tableCss';
import ScheduleLssTable from './ScheduleLssTable';
import ScheduleCssTable from './ScheduleCssTable';
import ScheduleClassDetail from './ScheduleClassDetail';
import UpcomingSessionsPage from './UpcomingSessionsPage';
import CreateEventModal from './CreateEventModal';
import StudentGroupModal from '../../pages/student-groups/_components/StudentGroupModal';
import { getListOfCohorts, getListOfGroups, getStudentGroupGlobalData } from '../../services/apiService';
import { PageHeader } from '../../extras/PageLayout';

const TAB_STYLE_BASE = {
  padding: '8px 20px',
  fontSize: 13,
  fontWeight: 600,
  background: '#F3F4F6',
  border: 'none',
  cursor: 'pointer',
  borderRadius: 6,
  color: '#6B7280',
};

const TAB_STYLE_ACTIVE = {
  ...TAB_STYLE_BASE,
  background: '#4F46E5',
  color: '#fff',
};

function ManageClassroom() {
  const [allCohorts, setAllCohorts] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [groupGlobals, setGroupGlobals] = useState({ cohort: [], almaXCohort: [], program: { course: [], plan: [], subplan: [] } });
  const [mainTab, setMainTab] = useState('scheduled');
  const [subTab, setSubTab] = useState('lss');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [showCreateEvent, setShowCreateEvent] = useState(false);
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  const [cssRefreshCounter, setCssRefreshCounter] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const cohorts = await getListOfCohorts();
        const groups = await getListOfGroups();
        setAllCohorts(cohorts.map((item) => ({ ...item, cohortName: item.name })));
        setAllGroups(groups?.data?.map((item) => ({ ...item, groupName: item.groupName })));
      } catch (error) {
        console.error(error);
      }
    })();
    (async () => {
      try {
        const res = await getStudentGroupGlobalData();
        const data = res?.data || res;
        setGroupGlobals({
          cohort: Array.isArray(data?.cohort) ? data.cohort : [],
          almaXCohort: Array.isArray(data?.almaXCohort) ? data.almaXCohort : [],
          program: {
            course: Array.isArray(data?.program?.course) ? data.program.course : [],
            plan: Array.isArray(data?.program?.plan) ? data.program.plan : [],
            subplan: Array.isArray(data?.program?.subplan) ? data.program.subplan : [],
          },
        });
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  if (selectedEvent) {
    return (
      <ScheduleClassDetail
        event={selectedEvent}
        onBack={() => setSelectedEvent(null)}
        allCohorts={allCohorts}
      />
    );
  }

  if (selectedGroup) {
    return (
      <UpcomingSessionsPage
        group={selectedGroup}
        onBack={() => setSelectedGroup(null)}
      />
    );
  }

  return (
    <div>
      <PageHeader
        title="Manage Classroom"
        subtitle="Schedule and manage classroom sessions"
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <button
          onClick={() => setMainTab('scheduled')}
          style={mainTab === 'scheduled' ? TAB_STYLE_ACTIVE : TAB_STYLE_BASE}
        >
          Schedule Classes
        </button>
        <button
          onClick={() => setMainTab('completed')}
          style={mainTab === 'completed' ? TAB_STYLE_ACTIVE : TAB_STYLE_BASE}
        >
          Completed Classes
        </button>
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid #E5E7EB', marginBottom: 20 }}>
        <button
          onClick={() => setSubTab('lss')}
          style={{
            padding: '8px 20px',
            fontSize: 13,
            fontWeight: 600,
            background: 'none',
            border: 'none',
            borderBottom: subTab === 'lss' ? '2px solid #4F46E5' : '2px solid transparent',
            cursor: 'pointer',
            color: subTab === 'lss' ? '#4F46E5' : '#6B7280',
          }}
        >
          LSS
        </button>
        <button
          onClick={() => setSubTab('css')}
          style={{
            padding: '8px 20px',
            fontSize: 13,
            fontWeight: 600,
            background: 'none',
            border: 'none',
            borderBottom: subTab === 'css' ? '2px solid #4F46E5' : '2px solid transparent',
            cursor: 'pointer',
            color: subTab === 'css' ? '#4F46E5' : '#6B7280',
          }}
        >
          CSS
        </button>
      </div>

      {mainTab === 'scheduled' && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginBottom: 16 }}>
          <button
            style={{
              border: '1px solid #5147ef',
              background: '#fff',
              color: '#5147ef',
              borderRadius: 4,
              padding: '8px 16px',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Upcoming Sessions
          </button>
          {subTab === 'lss' ? (
            <button
              onClick={() => setShowCreateEvent(true)}
              style={{
                border: 'none',
                background: '#4F46E5',
                color: '#fff',
                borderRadius: 4,
                padding: '8px 16px',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Add New Event
            </button>
          ) : (
            <button
              onClick={() => setShowCreateGroup(true)}
              style={{
                border: 'none',
                background: '#4F46E5',
                color: '#fff',
                borderRadius: 4,
                padding: '8px 16px',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Add New Group
            </button>
          )}
        </div>
      )}

      {mainTab === 'scheduled' && subTab === 'lss' && (
        <ScheduleLssTable
          allCohorts={allCohorts}
          onViewClasses={(row) => setSelectedEvent(row)}
        />
      )}

      {mainTab === 'scheduled' && subTab === 'css' && (
        <ScheduleCssTable
          onViewSessions={(row) => setSelectedGroup(row)}
          refreshCounter={cssRefreshCounter}
        />
      )}

      {mainTab === 'completed' && subTab === 'lss' && allCohorts?.length > 0 && (
        <ManageClassroomTable allCohorts={allCohorts} activeTab="LSS" />
      )}

      {mainTab === 'completed' && subTab === 'css' && allGroups?.length > 0 && (
        <ManageClassroomCssTable allGroups={allGroups} activeTab="CSS" />
      )}

      <CreateEventModal
        open={showCreateEvent}
        onClose={() => setShowCreateEvent(false)}
        allCohorts={allCohorts}
      />

      {showCreateGroup && (
        <StudentGroupModal
          openCreateModal={showCreateGroup}
          setOpenCreateModal={setShowCreateGroup}
          onRefresh={() => setCssRefreshCounter((c) => c + 1)}
          cohortListProp={groupGlobals.cohort}
          almaxCohortListProp={groupGlobals.almaXCohort}
          programOptionsProp={groupGlobals.program}
        />
      )}
    </div>
  );
}

export default ManageClassroom;
